import { Card, CardContent, Typography, Skeleton, Chip } from '@mui/material';
import AdminTable from '../../shared/AdminTable';
import { ChurnAnalysis, AdminTableColumn } from '../../../../types/admin';
import { formatNumber } from '../../../../utils/formatters';

interface ChurnAnalysisTableProps {
  data: ChurnAnalysis[];
  loading?: boolean;
}

export default function ChurnAnalysisTable({ data, loading }: ChurnAnalysisTableProps) {
  if (loading) {
    return (
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Churn Analysis by Tier
          </Typography>
          <Skeleton variant="rectangular" height={200} />
        </CardContent>
      </Card>
    );
  }

  const columns: AdminTableColumn<ChurnAnalysis>[] = [
    {
      key: 'tier',
      label: 'Tier',
      sortable: true,
      width: 150,
      render: (row) => <Chip label={row.tier.toUpperCase()} size="small" color="primary" />,
    },
    {
      key: 'active_subscriptions',
      label: 'Active Subscriptions',
      sortable: true,
      width: 180,
      render: (row) => formatNumber(row.active_subscriptions),
    },
    {
      key: 'churned_this_month',
      label: 'Churned This Month',
      sortable: true,
      width: 180,
      render: (row) => formatNumber(row.churned_this_month),
    },
    {
      key: 'churn_rate',
      label: 'Churn Rate',
      sortable: true,
      width: 120,
      render: (row) => `${row.churn_rate}%`,
    },
    {
      key: 'voluntary_churn',
      label: 'Voluntary Churn',
      sortable: true,
      width: 150,
      render: (row) => formatNumber(row.voluntary_churn),
    },
    {
      key: 'involuntary_churn',
      label: 'Involuntary Churn',
      sortable: true,
      width: 160,
      render: (row) => formatNumber(row.involuntary_churn),
    },
  ];

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Churn Analysis by Tier
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Monthly churn breakdown by subscription tier
        </Typography>
        <AdminTable columns={columns} data={data} isLoading={loading} />
      </CardContent>
    </Card>
  );
}
